import { render, staticRenderFns } from "./ListTvGroups.vue?vue&type=template&id=34047013&scoped=true&"
import script from "./ListTvGroups.vue?vue&type=script&lang=js&"
export * from "./ListTvGroups.vue?vue&type=script&lang=js&"
import style0 from "./ListTvGroups.vue?vue&type=style&index=0&id=34047013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34047013",
  null
  
)

export default component.exports